<template>
  <div class="lang">
      <button ref="button" class="lang-btn" @click.stop="openLang = !openLang"><img src="@/assets/img/client/icon-lang.png"></button>
      <fade-transition mode="out-in">
        <ul key="lang" v-show="openLang" v-click-outside="onClose">
          <li><button @click="setLang('ja'); openLang = false" type="button" class="chineseCnBtn" v-show="activeLanguage !== 'ja'">{{'日本語'}}</button></li>
          <li><button @click="setLang('en'); openLang = false" type="button" class="englishBtn" v-show="activeLanguage !== 'en'">{{'English'}}</button></li>
          <li><button @click="setLang('zh-cn'); openLang = false" type="button" class="chineseCnBtn" v-show="activeLanguage !== 'zh-cn'">{{'简体中文'}}</button></li>
          <li><button @click="setLang('zh-tw'); openLang = false" type="button" class="chineseBtn" v-show="activeLanguage !== 'zh-tw'">{{'繁體中文'}}</button></li>
        </ul>
      </fade-transition>
    </div>
</template>

<script>
import FadeTransition from '@/views/client/FadeTransition'
import Vue from 'vue'
import { mapState, mapActions } from 'vuex'

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.eventSetDrag = function () {
      el.setAttribute('data-dragging', 'yes')
    }
    el.eventClearDrag = function () {
      el.removeAttribute('data-dragging')
    }
    el.eventOnClick = function (event) {
      var dragging = el.getAttribute('data-dragging')
      if (!(el === event.target || el.contains(event.target)) && !dragging) {
        vnode.context[binding.expression](event)
      }
    }
    document.addEventListener('touchstart', el.eventClearDrag)
    document.addEventListener('touchmove', el.eventSetDrag)
    document.addEventListener('click', el.eventOnClick)
    document.addEventListener('touchend', el.eventOnClick)
  },
  unbind: function (el) {
    document.removeEventListener('touchstart', el.eventClearDrag)
    document.removeEventListener('touchmove', el.eventSetDrag)
    document.removeEventListener('click', el.eventOnClick)
    document.removeEventListener('touchend', el.eventOnClick)
    el.removeAttribute('data-dragging')
  }
})

export default {
  data () {
    return {
      openLang: false,
      currentlanguage: Vue.$cookies.get('language'),
      activeLanguage: this.$route.params.lang
    }
  },
  computed: {
    ...mapState(['language'])
  },
  methods: {
    ...mapActions(['setLanguage']),
    onClose () {
      this.openLang = false
    },
    setLang (lang) {
      this.$router.push({ params: { lang: lang } })
      window.location.reload()
    }
  },
  components: {
    FadeTransition
  }
}
</script>
